<template>
  <v-app id="stock-metric-app">
    <v-main>
      <v-container>
        <v-dialog
    v-model="fullscreen"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
  <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="hide_fullscreen()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Stock Chart</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

            </v-toolbar-items>
          </v-toolbar>
          <v-card-text style="height:100%;">
            <div class="chart-wrapper" style="height:100%;">
            <div  class="highcharts-stocktools-wrapper highcharts-bindings-container highcharts-bindings-wrapper">
            <div class="highcharts-menu-wrapper">
              <v-row dense class="highcharts-stocktools-toolbar stocktools-toolbar">
                   <v-col cols="12">
                      <v-menu
                                                  offset-y
                                                  left
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-btn small title="Add New Data to Chart" outlined
                                                      v-on="on" class="ml-3"
                                                    ><v-icon>addchart</v-icon>
                                                    13F/Other Data
                                                    </v-btn>
                                                  </template>
                                                  <v-list dense >
                                                    <v-list-item v-for="metric in config.metrics" :key="metric.id">
                                                      <v-list-item-action>
                  <v-checkbox @click="toggle_metric(metric)"
                    v-model="metric.visible"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                                                      <v-list-item-title>{{metric.name}}</v-list-item-title>
                                                    </v-list-item>
                                                  </v-list>
                                                </v-menu>
                         <v-btn class="highcharts-indicators" small outlined title="Add New Indicator"><v-icon>trending_up</v-icon>Price Indicators</v-btn>

                          <v-menu
                                                      offset-y
                                                      left
                                                    >
                                                      <template v-slot:activator="{ on }">
                                                        <v-btn small title="Compare to another ticker" outlined
                                                          v-on="on" class="ml-3"
                                                        ><v-icon>bolt</v-icon>
                                                        Compare To
                                                        </v-btn>
                                                      </template>
                                                      <v-list dense>
                                                        <v-list-item>
                                                          <v-checkbox @click="toggle_compare_to()"
                                                            v-model="config.compare_to_sptr"
                                                            color="primary"
                                                          ></v-checkbox>
                                                          <v-list-item-title>S&amp;P 500 TR</v-list-item-title>
                                                        </v-list-item>
                                                      </v-list>
                                                    </v-menu>


                         <v-btn outlined small icon title="Export to CSV" @click="export_csv()"><v-icon>get_app</v-icon></v-btn>
                        <v-menu
                          offset-y
                          left class="highcharts-series-type-ohlc"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn small icon title="Change Chart Type" outlined
                              v-on="on"
                            ><v-icon>poll</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense class="highcharts-submenu-wrapper">
                            <v-list-item class="highcharts-series-type-ohlc" @click="update_chart_type('ohlc')">
                              <v-list-item-title>OHLC</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="highcharts-series-type-line" @click="update_chart_type('line')">
                              <v-list-item-title>Line</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="highcharts-series-type-candlestick" @click="update_chart_type('candlestick')">
                              <v-list-item-title>Candlestick</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                      <v-btn outlined small icon @click="show_fullscreen()"><v-icon>fullscreen</v-icon></v-btn>
                   </v-col>
              </v-row>
              </div>
              </div>

                <div id="chart_container_fullscreen" style="height:100%"></div>
            </div>
          </v-card-text>
        </v-card>
  </v-dialog>

        <div class="chart-wrapper">
        <div  class="highcharts-stocktools-wrapper highcharts-bindings-container highcharts-bindings-wrapper">
        <div class="highcharts-menu-wrapper">
          <v-row dense class="highcharts-stocktools-toolbar stocktools-toolbar">
               <v-col cols="12">
                  <v-menu
                                              offset-y
                                              left
                                            >
                                              <template v-slot:activator="{ on }">
                                                <v-btn small title="Add New Data to Chart" outlined
                                                  v-on="on" class="ml-3"
                                                ><v-icon>addchart</v-icon>
                                                13F/Other Data
                                                </v-btn>
                                              </template>
                                              <v-list dense >
                                                <v-list-item v-for="metric in config.metrics" :key="metric.id">
                                                  <v-list-item-action>
              <v-checkbox @click="toggle_metric(metric)"
                v-model="metric.visible"
                color="primary"
              ></v-checkbox>
            </v-list-item-action>
                                                  <v-list-item-title>{{metric.name}}</v-list-item-title>
                                                </v-list-item>
                                              </v-list>
                                            </v-menu>
                     <v-btn class="highcharts-indicators" small outlined title="Add New Indicator"><v-icon>trending_up</v-icon>Price Indicators</v-btn>

                      <v-menu
                                                  offset-y
                                                  left
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-btn small title="Compare to another ticker" outlined
                                                      v-on="on" class="ml-3"
                                                    ><v-icon>bolt</v-icon>
                                                    Compare To
                                                    </v-btn>
                                                  </template>
                                                  <v-list dense>
                                                    <v-list-item>
                                                      <v-checkbox @click="toggle_compare_to()"
                                                        v-model="config.compare_to_sptr"
                                                        color="primary"
                                                      ></v-checkbox>
                                                      <v-list-item-title>S&amp;P 500 TR</v-list-item-title>
                                                    </v-list-item>
                                                  </v-list>
                                                </v-menu>


                     <v-btn outlined small icon title="Export to CSV" @click="export_csv()"><v-icon>get_app</v-icon></v-btn>
                    <v-menu
                      offset-y
                      left class="highcharts-series-type-ohlc"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn small icon title="Change Chart Type" outlined
                          v-on="on"
                        ><v-icon>poll</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense class="highcharts-submenu-wrapper">
                        <v-list-item class="highcharts-series-type-ohlc" @click="update_chart_type('ohlc')">
                          <v-list-item-title>OHLC</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="highcharts-series-type-line" @click="update_chart_type('line')">
                          <v-list-item-title>Line</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="highcharts-series-type-candlestick" @click="update_chart_type('candlestick')">
                          <v-list-item-title>Candlestick</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                  <v-btn outlined small icon @click="show_fullscreen()"><v-icon>fullscreen</v-icon></v-btn>
               </v-col>
          </v-row>
          </div>
          </div>

            <div id="chart_container"></div>
        </div>


        <v-dialog
      v-model="edit_metric_dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{editMetricTitle}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="editMetric && editMetric.id && editMetric.id==9">
                <v-col cols="12">
                  <v-select style="max-width:150px;"
                    v-model="editMetric.days"
                    :items="ma_days"
                    label="Moving Avg Days"
                    hint="Moving Average"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
            </v-row>
            <v-row v-else-if="editMetric && editMetric.id && editMetric.id==11">
                <v-col cols="12">
                  <v-select  style="max-width:300px;"
                    v-model="editMetric.days"
                    dense
                    hide-details
                    outlined
                    :items="stocks_vs_sp_months"
                    item-text="text"
                    item-value="value"
                    prefix="over the past"
                    label="Trading days"
                  />

                </v-col>
            </v-row>
            <v-row v-else-if="editMetric && editMetric.id && editMetric.id==10">
                <v-col cols="12">
                  <v-select style="max-width:200px;"
                    v-model="editMetric.days"
                    :items="[2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]"
                    label="Moving Avg Days"
                    hint="Moving Average"
                    dense
                    hide-details
                    outlined
                  />

                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editMetric.stddev"
                    dense
                    hide-details
                    outlined
                    label="# Standard Deviations (max 5)"
                  />
                </v-col>
            </v-row>
<v-row v-else-if="editMetric && editMetric.id && editMetric.id==12">
                <v-col cols="12">
                  <v-select style="max-width:150px;"
                    v-model="editMetric.days"
                    :items="ma_days"
                    label="EMA Days"
                    hint="Exponential Moving Average (EMA)"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
            </v-row>
            <v-row v-else-if="editMetric && editMetric.id && editMetric.id==13">
                <v-col cols="12">
                  <v-select style="max-width:150px;"
                    v-model="editMetric.days"
                    :items="rsi_days"
                    label="RSI Days"
                    hint="RSI Days"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
            </v-row>
            <v-row v-else-if="editMetric && editMetric.id && editMetric.id==14">
                <v-col cols="12">
                  <v-select style="max-width:150px;"
                    v-model="editMetric.days"
                    :items="ma_days"
                    label="Moving Avg Days"
                    hint="MACD Fast Days"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>

                 <v-col cols="12">
                      <v-select style="max-width:150px;"
                        v-model="editMetric.days2"
                        :items="ma_days"
                        label="Moving Avg Days"
                        hint="MACD Slow Days"
                        dense
                        hide-details
                        outlined
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-select style="max-width:150px;"
                        v-model="editMetric.signal"
                        :items="ma_days"
                        label="Signal"
                        hint="MACD Signal"
                        dense
                        hide-details
                        outlined
                      />
                    </v-col>
            </v-row>

          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancelMetric()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!Valid"
            @click="saveMetric()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
window.Highcharts = require('highcharts/highstock');
require('highcharts/modules/full-screen')(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);

export default {
  components: {

  },
  mixins: [],

  data: () => ({
    ma_days: [],
    rsi_days:[],
    searching: false,
    editMetric:null,
    defaultMetric:{id:-1,name:""},
    edit_metric_dialog:false,
    fullscreen: false,
    editedIndex:-1,
    metrics_chart:false,
    editMetricTitle:'',
    results: [],
    mas:{},
    macds:{},
    rsis:{},
    emas:{},
    stddevs:{},
    perf_vsp:{},
sptr_data:[],
    dates:[{id:1,description:'Max'},{id:2,description:'1Wk'},
    {id:3,description:'1M'},
    {id:4,description:'3M'},
    {id:5,description:'6M'},
    {id:6,description:'9M'},
    {id:7,description:'1Y'},
    {id:8,description:'2Y'},
    {id:9,description:'3Y'},
    {id:10,description:'5Y'},
    {id:11,description:'10Y'}],
    config:{date:0,chart_type:'line',compare_to_sptr:false,
      metrics:[
       {id:1,name:"Net Buys",data:[],yAxis:2,type:"spline",visible: false,turboThreshold:0,fetch_url:false, identifier:"net_buys"},
               {id:4,name:"Average 13F Ranking",data:[],yAxis:2,type:"spline",turboThreshold:0, visible: false,fetch_url:false,identifier:"average_ranking"},
               {id:5,name:"Total 13F Shares Held(split-adjusted)",data:[],yAxis:1,type:"spline",visible: false,turboThreshold:0,fetch_url:false,identifier:"total_shares"},
               {id:6,name:"# Funds Holding",data:[],yAxis:2,visible: true,turboThreshold:0,fetch_url:false,identifier:"held_by"},
               {id:7,name:"Short Volume",data:[],yAxis:1,type:"column",visible: false,turboThreshold:0,fetch_url:false,identifier:"avg_short_volume"},
               {id:8,name:"PUT/CALL Ratio",data:[],yAxis:3,type:"spline",visible: false,turboThreshold:0,fetch_url:false,identifier:"put_call_ratio"},
               {id:15,name:"13F AUM",data:[],yAxis:4,type:"spline",visible: false,turboThreshold:0,fetch_url:false,identifier:"market_cap_13f"}
      ]
    },
    available_metrics:[,
        {id:9,name:"SMA",data:[],yAxis:1,type:"line",visible: false,turboThreshold:0,fetch_url:'moving_average', multiple:true, days:50},
        {id:10,name:"Bollinger Band",data:[],yAxis:1,type:"arearange",visible: false,turboThreshold:0,fetch_url:'bb', multiple:true, days:240,new_axis:true, stddev:2},
        {id:11,name:"Perf vs S&P",data:[],yAxis:-1,type:"line",visible: false,turboThreshold:0,fetch_url:'perf_vsp', multiple:true, days:240,new_axis:true},
        {id:12,name:"EMA",data:[],yAxis:1,type:"line",visible: false,turboThreshold:0,fetch_url:'ema', multiple:true, days:26},
        {id:13,name:"RSI",data:[],yAxis:1,type:"line",visible: false,turboThreshold:0,fetch_url:'rsi', multiple:true, days:14},
        {id:14,name:"MACD",data:[],yAxis:1,type:"line",visible: false,turboThreshold:0,fetch_url:'macd', multiple:true, days:12, days2:26, signal:9},
    ],
    stocks_vs_sp_months: [{ text: '20 trading days', value: 20 },
      { text: '60 trading days', value: 60 },
      { text: '120 trading days', value: 120 },
      { text: '180 trading days', value: 180 },
      { text: '240 trading days', value: 240 },
      { text: '480 trading days', value: 480 }

    ],
  }),

  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    },
    Valid() {
      var valid=true;
      var editMetric=this.editMetric
      if (editMetric){
        if (editMetric.id==9){
            if (!editMetric.days || this.ma_days.indexOf(parseInt(editMetric.days))<0){
              valid=false;
            }
        }
        else if (editMetric.id==10){
          if (!editMetric.days || this.ma_days.indexOf(parseInt(editMetric.days))<0 || parseInt(editMetric.days)>30){
            valid=false;
          }
          if (!editMetric.stddev || parseInt(editMetric.stddev)<0 || parseInt(editMetric.stddev)>5){
            valid=false;
          }
        }
        else if (editMetric.id==11){
          if (!editMetric.days || [20,60,120,180,240,480].indexOf(parseInt(editMetric.days))<0){
            valid=false;
          }
        }
      }
      return valid;
    }
  },

  watch: {
   /* config: {
          deep: true,
          handler () {
            this.build_chart2()
          }
        },*/
  },

  mounted () {
  setTimeout(() => this.refresh(),100);
  /*this.$nextTick(() => {
         this.refresh();
        })*/

  },

  created () {
    for (var i = 2; i < 71; i++)
    { this.ma_days.push(i) }
    for (var i = 75; i < 301; i += 5)
    { this.ma_days.push(i) }

    this.rsi_days=[];
        for (var i=5;i<51;i++){
          this.rsi_days.push(i);
        }
  },

  methods: {
    update_chart_type(ctype){
      this.config.chart_type=ctype;
      setTimeout(() => this.build_chart2(),100);
    },
    toggle_compare_to(){
      if (this.config.compare_to_sptr && !this.sptr_data || this.sptr_data.length==0){
        //load prices first
        axios.get("/dashboard/fetch_sptr?stock_id="+window.whalewisdom.Stock.stock_id)
                .then(response => {
                  this.searching = false
                  this.sptr_data = response.data
                    setTimeout(() => this.build_chart2(),100);
                })
                .catch(error => {
                  this.searching = false
                  // var data=response.data;
                  this.ErrorMessage = error
                })
                .then(() => (this.searching = false))
        return;
      }
      else{
        setTimeout(() => this.build_chart2(),100);
      }

    },
    cancelMetric(){
      this.edit_metric_dialog = false
      setTimeout(() => {
        this.editMetric = Object.assign({}, this.defaultMetric)
        this.editedIndex = -1
      }, 300)
    },
    saveMetric(){
      if (this.editMetric.id==9){
        this.editMetric.name=this.editMetric.days+" day moving average"
        this.editMetric.visible=true
        //ma
        if (!this.mas[this.editMetric.days]){
          //load ajax
          axios.get("/dashboard/fetch_mas?stock_id="+window.whalewisdom.Stock.stock_id+"&days="+this.editMetric.days)
                  .then(response => {
                    this.searching = false
                    var data = response.data
                    this.mas[this.editMetric.days]=data;
                    if (this.editedIndex > -1) {
                      Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
                    } else {
                      this.config.metrics.push(this.editMetric)
                    }


                    this.cancelMetric();
                  })
                  .catch(error => {
                    this.searching = false
                    // var data=response.data;
                    this.ErrorMessage = error
                  })
                  .then(() => (this.searching = false))
          return;
        }
        else{

        }
      }
      else if (this.editMetric.id==11){
        this.editMetric.name=this.editMetric.days+" day performance vs S&P"
        this.editMetric.visible=true
        //ma
        if (!this.perf_vsp[this.editMetric.days]){
          //load ajax
          axios.get("/dashboard/fetch_perf_vsp?stock_id="+window.whalewisdom.Stock.stock_id+"&days="+this.editMetric.days)
                  .then(response => {
                    this.searching = false
                    var data = response.data
                    this.perf_vsp[this.editMetric.days]=data;
                    if (this.editedIndex > -1) {
                      Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
                    } else {
                      this.config.metrics.push(this.editMetric)
                    }


                    this.cancelMetric();
                  })
                  .catch(error => {
                    this.searching = false
                    // var data=response.data;
                    this.ErrorMessage = error
                  })
                  .then(() => (this.searching = false))
          return;
        }
        else{

        }
      }
      else if (this.editMetric.id==10){
        this.editMetric.name=this.editMetric.days+" day, " + this.editMetric.stddev + " stddev bband"
        this.editMetric.visible=true
        //ma
        if (!this.mas[this.editMetric.days] || !this.stddevs[this.editMetric.stddev]){
          //load ajax
          axios.get("/dashboard/fetch_bb?stock_id="+window.whalewisdom.Stock.stock_id+"&days="+this.editMetric.days+"&stddev="+this.editMetric.stddev)
                  .then(response => {
                    this.searching = false
                    var data = response.data
                    this.mas[this.editMetric.days]=data.days
                    this.stddevs[this.editMetric.days]=data.stddev
                    if (this.editedIndex > -1) {
                      Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
                    } else {
                      this.config.metrics.push(this.editMetric)
                    }


                    this.cancelMetric();
                  })
                  .catch(error => {
                    this.searching = false
                    // var data=response.data;
                    this.ErrorMessage = error
                  })
                  .then(() => (this.searching = false))
          return;
        }
        else{

        }
      }
       else if (this.editMetric.id==12){
       //EMA
              this.editMetric.name=this.editMetric.days+" day EMA"
              this.editMetric.visible=true
              //ma
              if (!this.mas[this.editMetric.days]){
                //load ajax
                axios.get("/dashboard/fetch_emas?stock_id="+window.whalewisdom.Stock.stock_id+"&days="+this.editMetric.days)
                        .then(response => {
                          this.searching = false
                          var data = response.data
                          this.emas[this.editMetric.days]=data;
                          if (this.editedIndex > -1) {
                            Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
                          } else {
                            this.config.metrics.push(this.editMetric)
                          }


                          this.cancelMetric();
                        })
                        .catch(error => {
                          this.searching = false
                          // var data=response.data;
                          this.ErrorMessage = error
                        })
                        .then(() => (this.searching = false))
                return;
              }
              else{

              }
            }
       if (this.editMetric.id==13){
       //RSI
              this.editMetric.name=this.editMetric.days+" day RSI"
              this.editMetric.visible=true
              //ma
              if (!this.mas[this.editMetric.days]){
                //load ajax
                axios.get("/dashboard/fetch_rsis?stock_id="+window.whalewisdom.Stock.stock_id+"&days="+this.editMetric.days)
                        .then(response => {
                          this.searching = false
                          var data = response.data
                          this.rsis[this.editMetric.days]=data;
                          if (this.editedIndex > -1) {
                            Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
                          } else {
                            this.config.metrics.push(this.editMetric)
                          }


                          this.cancelMetric();
                        })
                        .catch(error => {
                          this.searching = false
                          // var data=response.data;
                          this.ErrorMessage = error
                        })
                        .then(() => (this.searching = false))
                return;
              }
              else{

              }
            }
       if (this.editMetric.id==14){
       //MACD
              this.editMetric.name=this.editMetric.days+", "+ this.editMetric.days2+","+this.editMetric.signal +" MACD"
              this.editMetric.visible=true
              //ma
              if (!this.mas[this.editMetric.days]){
                //load ajax
                axios.get("/dashboard/fetch_macds?stock_id="+window.whalewisdom.Stock.stock_id+"&days="+this.editMetric.days+
                "&days2="+this.editMetric.days2+"&signal="+this.editMetric.signal)
                        .then(response => {
                          this.searching = false
                          var data = response.data
                          var key=this.editMetric.days+", "+ this.editMetric.days2+","+this.editMetric.signal
                          this.macds[key]=data;
                          if (this.editedIndex > -1) {
                            Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
                          } else {
                            this.config.metrics.push(this.editMetric)
                          }


                          this.cancelMetric();
                        })
                        .catch(error => {
                          this.searching = false
                          // var data=response.data;
                          this.ErrorMessage = error
                        })
                        .then(() => (this.searching = false))
                return;
              }
              else{

              }
            }
      if (this.editedIndex > -1) {
        Object.assign(this.config.metrics[this.editedIndex], this.editMetric)
      } else {
        this.config.metrics.push(this.editMetric)
      }

    this.cancelMetric();
    },
   toggle_metric:function(metric){
      setTimeout(() => this.build_chart2(),100);
    },
    edit_metric:function(metric){
      this.editedIndex = this.config.metrics.indexOf(metric)
      this.editMetric = Object.assign({}, metric)
      this.edit_metric_dialog = true
      this.editMetricTitle="Edit"
    },
    export_csv:function(){
        if (!window.whalewisdom.Utilities.isLoggedIn()){
            window.whalewisdom.Utilities.show_alert("Please Log In First",
                "Please create an account or log into your existing account first.  A premium subscription is also required for this feature.");
            return;
        }
        if (!window.whalewisdom.Utilities.isSubscriber()) {
            window.whalewisdom.Utilities.show_alert("Subscription Required", "This feature requires a subscription to use.");
            return;
        }
        var url = "/stock/get_current_chart_data_excel?stock_id="+window.whalewisdom.Stock.stock_id+
            "&authenticity_token="+encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        window.location = url;
    },
    show_fullscreen(){
    this.metrics_chart.fullscreen.toggle();
      //    this.fullscreen=true;
       //   setTimeout(() => this.build_chart2(),100);
    },
    hide_fullscreen(){
          this.fullscreen=false;
          setTimeout(() => this.build_chart2(),100);
    },
    refresh:function(){
        axios.get("/stock/get_current_chart_data?stock_id="+window.whalewisdom.Stock.stock_id+
                "&authenticity_token="+encodeURIComponent($('meta[name="csrf-token"]').attr("content")))
                .then(response => {
                  this.searching = false
                  var data = response.data
                  if (data.length<4)
                    return;
                  this.results = data
                  this.build_chart2();
                })
                .catch(error => {
                  this.searching = false
                  // var data=response.data;
                  this.ErrorMessage = error
                })
                .then(() => (this.loading = false))
    },
    filterData(results, days, months, years){
        var data=[]
        var d=new Date();
        if (days>0){
          d.setDate(d.getDate()-days);
        }
        else if (months>0){
          d.setMonth(d.getMonth() - months);
        }
        else if (years>0){
          d.setFullYear( d.getFullYear() - years );
        }
        data=results.filter(el => new Date(el.quarter_description)>d);
        return data;
    },
    find_series(name){
      if (this.s.name==name)
        return this.s;
      else if (this.s2.name==name)
        return this.s2;
        else if (this.s3.name==name)
          return this.s3;
          else if (this.s4.name==name)
            return this.s4;
            else if (this.s5.name==name)
              return this.s6;
              else if (this.s6.name==name)
                return this.s6;
                else if (this.s7.name==name)
                  return this.s7;
                  else if (this.s8.name==name)
                    return this.s8;
        else{
          for (var i=0;i<this.config.metrics.length;i++){
            var series=this.config.metrics[i]
            if (series.name==name)
            return series;
          }
        }
        return null;
    },
    build_chart:function(){
        var data=[];
        var that=this;
        var date=this.dates[this.config.date].id
        switch (date){
          case 1:
            data=this.results;
          break;
          case 2://1 wk
            data=this.filterData(this.results, 7,0,0)
          break;
          case 3://1m
            data=this.filterData(this.results, 0,1,0)
          break;
          case 4://3m
            data=this.filterData(this.results, 0,3,0)
          break;
          case 5://6m
            data=this.filterData(this.results, 0,6,0)
          break;
          case 6://9m
            data=this.filterData(this.results, 0,9,0)
          break;
          case 7://1y
              data=this.filterData(this.results, 0,0,1)
          break;
          case 8://2y
            data=this.filterData(this.results, 0,0,2)
          break;
          case 9://3y
              data=this.filterData(this.results, 0,0,3)
          break;
          case 10://5y
              data=this.filterData(this.results, 0,0,5)
          break;
          case 11://10y
            data=this.filterData(this.results, 0,0,10)
          break;
        }

        this.setup_theme();
        // Apply the theme
                        var show_stock_price=false;
                        var show_shorts=false;
                        var show_volume=false;
                        for (var showindex=0;showindex<data.length;showindex++){
                            var rec=data[showindex];
                            if (rec.closing_price){
                                show_stock_price=true;
                                show_volume=true;
                            }
                            if (rec.avg_short_volume){
                                show_shorts=true;
                            }
                            if (show_shorts && show_stock_price)
                                break;

                        }
                        var num_axis=4
                        var series_data=[];
                        this.s.data=[];

                        series_data.push(this.s);
                        this.s2.data=[];

                        series_data.push(this.s2);
                        this.s3.data=[];


                        series_data.push(this.s3);
                        this.s5.data=[];

                        series_data.push(this.s5);

                        if (show_stock_price){
                            num_axis+=1;
                            this.s4.data=[];

                            series_data.push(this.s4);
                        }
                        if (show_volume){
                            num_axis+=1;
                            this.s7.data=[];

                            series_data.push(this.s7);
                        }
                        if (show_shorts){
                            num_axis+=1;
                            this.s6.data=[];

                            series_data.push(this.s6);
                        }
                        this.s8.data=[];
                        this.s8.yAxis=num_axis
                        series_data.push(this.s8)
                        num_axis+=1;
                        var indicators=[]
                        for (var metricindex=0;metricindex<this.config.metrics.length;metricindex++){
                          var metric=cloneDeep(this.config.metrics[metricindex]);
                          if (metric.new_axis){

                            metric.yAxis=num_axis
                            num_axis+=1
                            /*if (metric.id==10)
                            {
                                var metric2=cloneDeep(this.config.metrics[metricindex]);
                                metric2.lower_band=true;
                                metric2.yAxis=num_axis
                                metric2.data=[]
                                series_data.push(metric2);
                                indicators.push(metric2)
                              num_axis+=1
                            }*/
                          }
                          metric.data=[]
                      //    metric.visible=true;

                          series_data.push(metric);
                          indicators.push(metric)
                        }
                        for (var j = 0; j < data.length; j++) {
                            var rec = data[j];
                           // var d =
                            this.s.data.push({name: rec.quarter_description,y: rec.net_buys});
                            this.s2.data.push({name: rec.quarter_description, y: rec.average_ranking});
                            this.s3.data.push({name: rec.quarter_description, y: rec.held_by});
                            if (show_stock_price){
                                this.s4.data.push({name: rec.quarter_description, y: parseFloat(rec.closing_price)});
                            }
                            if (show_volume){
                                this.s7.data.push({name: rec.quarter_description, y: parseFloat(rec.total_volume)});
                            }
                            this.s5.data.push({name: rec.quarter_description, y: rec.total_shares});
                            if (show_shorts){
                                this.s6.data.push({name: rec.quarter_description,
                                    y: (rec.avg_short_volume ? parseFloat(rec.avg_short_volume)*1.0 : null)});
                            }
                            this.s8.data.push({name:rec.quarter_description,y: rec.put_call_ratio})

                            for (var metricindex=0;metricindex<indicators.length;metricindex++){
                              var metric=indicators[metricindex];
                              var row={name: rec.quarter_description,y: null}
                              if (metric.id==9){
                                metric.yAxis=this.s4.yAxis;
                                //ma
                                var days=this.mas[metric.days]
                                if (days && days[rec.quarter_description]){
                                  row.y=days[rec.quarter_description]
                                  metric.data.push(row)
                                }
                              }
                              if (metric.id==10){
                                //ma
                                var days=this.mas[metric.days]
                                var stddev=this.stddevs[metric.days]
                                metric.yAxis=this.s4.yAxis;
                                if (days && days[rec.quarter_description] && stddev && stddev[rec.quarter_description]){
                                  var y=0
                                  var ma=days[rec.quarter_description]
                                  var std=stddev[rec.quarter_description]

                                  row.low=ma-(metric.stddev*std)
                                  row.high=ma+(metric.stddev*std)
                                  metric.data.push(row)
                                }
                              }
                              else if (metric.id==11){
                                //ma
                                var days=this.perf_vsp[metric.days]
                                if (days && days[rec.quarter_description]){
                                  row.y=days[rec.quarter_description]
                                  metric.data.push(row)
                                }
                              }
                              else if (metric.id==12){
                              //ema
                              var days=this.emas[metric.days]
                              if (days && days[rec.quarter_description]){
                                row.y=days[rec.quarter_description]
                                metric.data.push(row)
                              }
                            }
                            else if (metric.id==13){
                              //rsi
                              var days=this.rsis[metric.days]
                              if (days && days[rec.quarter_description]){
                                row.y=days[rec.quarter_description]
                                metric.data.push(row)
                              }
                            }

                            else if (metric.id==14){
                          //macd
                          var days=this.macds[metric.days]
                          if (days && days[rec.quarter_description]){
                            row.y=days[rec.quarter_description]
                            metric.data.push(row)
                          }
                        }

                            }
                        }
                        var y_axis=[
                            {title:{text:"Net Buys"},opposite: false,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a');
                                } }},
                            {title:{text:"Average Ranking"},opposite: false,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a')
                                } }},
                            {title:{text:"# Funds"},opposite: false,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a');
                                } }},
                            {title:{text:"Total 13F Shares"},opposite: false,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a');
                                } }}
                        ];
                        if (show_stock_price){
                            y_axis.push({title:{text:"Stock Price"},opposite: true,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a');
                                } }});

                        }
                        if (show_volume){
                            y_axis.push({title:{text:"Volume"},opposite: true,labels:{
                                    formatter:function(){
                                        return numbro(this.value).format('0.0a');
                                    } }});
                        }

                        if (show_shorts){
                            y_axis.push({title:{text:"Short Volume"},opposite: true,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a');
                                } }});
                        }
                        y_axis.push({title:{text:"PUT/CALL Ratio"},opposite: true,visible:false,labels:{
                                formatter:function(){
                                    return numbro(this.value).format('0.0a');
                                } }});

                                for (var metricindex=0;metricindex<this.config.metrics.length;metricindex++){
                                  var metric=cloneDeep(this.config.metrics[metricindex]);
                                  if (metric.new_axis){
                                    y_axis.push({title:{text:metric.name},opposite: false,labels:{
                                        formatter:function(){
                                            return numbro(this.value).format('0.0a');
                                        } }});
                                  }

                                }

                  //      whalewisdom.Stock.draw_short_chart();

                        this.metrics_chart=Highcharts.chart('chart_container'+(this.fullscreen ? '_fullscreen' : ''), {


                            xAxis: {
                                tickInterval: 90,
                                type: 'category'
                            },

                            yAxis: y_axis,
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            },

                            plotOptions: {
                                turboThreshold:0,
                                series: {
                                  events: {
                                      legendItemClick: function () {
                                          var series=that.find_series(this.name)
                                          series.visible=!series.visible
                                      }
                                  }
                                }
                            },
                             title: {
                                text: '13F Metrics'
                            },

                            subtitle: {
                                text: (!whalewisdom.Utilities.isSubscriber() ? " (subscribe to see data as far back as 2001)" : "")
                            },
                            credits: {
                                enabled: false
                            },
                            tooltip: {
                                shared: true,
                                crosshairs: [true,true]
                            },
                            exporting: {
                                chartOptions: { // specific options for the exported image
                                    plotOptions: {
                                        series: {
                                            dataLabels: {
                                                enabled: true
                                            }
                                        }
                                    }
                                },
                                fallbackToExportServer: false
                            },
                            chart: {
                                // type:'bar',
                                zoomType: 'x'
                            },

                            series:series_data

                        });


    },
    setup_theme(){
    Highcharts.theme = {
                              //  colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
                              //      '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
                                chart: {
                                    backgroundColor: {
                                        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                        stops: [
                                            [0, '#2a2a2b'],
                                            [1, '#3e3e40']
                                        ]
                                    },
                                    style: {
                                        fontFamily: '\'Unica One\', sans-serif'
                                    },
                                    plotBorderColor: '#606063'
                                },
                                title: {
                                    style: {
                                        color: '#E0E0E3',
                                        //textTransform: 'uppercase',
                                        fontSize: '18px'
                                    }
                                },
                                subtitle: {
                                    style: {
                                        color: '#E0E0E3',
                                        textTransform: 'uppercase'
                                    }
                                },
                                xAxis: {
                                    gridLineColor: '#707073',
                                    labels: {
                                        style: {
                                            color: '#E0E0E3'
                                        }
                                    },
                                    lineColor: '#707073',
                                    minorGridLineColor: '#505053',
                                    tickColor: '#707073',
                                    title: {
                                        style: {
                                            color: '#A0A0A3'

                                        }
                                    }
                                },
                                yAxis: {
                                    gridLineColor: '#707073',
                                    labels: {
                                        style: {
                                            color: '#E0E0E3'
                                        }
                                    },
                                    lineColor: '#707073',
                                    minorGridLineColor: '#505053',
                                    tickColor: '#707073',
                                    tickWidth: 1,
                                    title: {
                                        style: {
                                            color: '#A0A0A3'
                                        }
                                    }
                                },
                                tooltip: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                                    style: {
                                        color: '#F0F0F0'
                                    }
                                },
                                plotOptions: {
                                    series: {
                                        dataLabels: {
                                            color: '#B0B0B3'
                                        },
                                        marker: {
                                            lineColor: '#333'
                                        }
                                    },
                                    boxplot: {
                                        fillColor: '#505053'
                                    },
                                    candlestick: {
                                        lineColor: 'white'
                                    },
                                    errorbar: {
                                        color: 'white'
                                    },
                                    column: {
                                        borderRadius: 1
                                    }
                                },
                                legend: {
                                    itemStyle: {
                                        color: '#E0E0E3'
                                    },
                                    itemHoverStyle: {
                                        color: '#FFF'
                                    },
                                    itemHiddenStyle: {
                                        color: '#606063'
                                    }
                                },
                                credits: {
                                    style: {
                                        color: '#666'
                                    }
                                },
                                labels: {
                                    style: {
                                        color: '#707073'
                                    }
                                },

                                drilldown: {
                                    activeAxisLabelStyle: {
                                        color: '#F0F0F3'
                                    },
                                    activeDataLabelStyle: {
                                        color: '#F0F0F3'
                                    }
                                },

                                navigation: {
                                    buttonOptions: {
                                        symbolStroke: '#DDDDDD',
                                        theme: {
                                            fill: '#505053'
                                        }
                                    }
                                },

                                // scroll charts
                                rangeSelector: {
                                    buttonTheme: {
                                        fill: '#505053',
                                        stroke: '#000000',
                                        style: {
                                            color: '#CCC'
                                        },
                                        states: {
                                            hover: {
                                                fill: '#707073',
                                                stroke: '#000000',
                                                style: {
                                                    color: 'white'
                                                }
                                            },
                                            select: {
                                                fill: '#000003',
                                                stroke: '#000000',
                                                style: {
                                                    color: 'white'
                                                }
                                            }
                                        }
                                    },
                                    inputBoxBorderColor: '#505053',
                                    inputStyle: {
                                        backgroundColor: '#333',
                                        color: 'silver'
                                    },
                                    labelStyle: {
                                        color: 'silver'
                                    }
                                },

                                navigator: {
                                    handles: {
                                        backgroundColor: '#666',
                                        borderColor: '#AAA'
                                    },
                                    outlineColor: '#CCC',
                                    maskFill: 'rgba(255,255,255,0.1)',
                                    series: {
                                        color: '#7798BF',
                                        lineColor: '#A6C7ED'
                                    },
                                    xAxis: {
                                        gridLineColor: '#505053'
                                    }
                                },

                                scrollbar: {
                                    barBackgroundColor: '#808083',
                                    barBorderColor: '#808083',
                                    buttonArrowColor: '#CCC',
                                    buttonBackgroundColor: '#606063',
                                    buttonBorderColor: '#606063',
                                    rifleColor: '#FFF',
                                    trackBackgroundColor: '#404043',

                                trackBorderColor: '#404043'
                                },

                                // special colors for some of the
                                legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
                                background2: '#505053',
                                dataLabelsColor: '#B0B0B3',
                                textColor: '#C0C0C0',
                                contrastTextColor: '#F0F0F3',
                                maskColor: 'rgba(255,255,255,0.3)'
                            };
Highcharts.setOptions(Highcharts.theme);
    },
    addPopupEvents(chart) {
        /*var closePopupButtons = document.getElementsByClassName('highcharts-close-popup');
        // Close popup button:
        Highcharts.addEvent(
            closePopupButtons[0],
            'click',
            function () {
                this.parentNode.style.display = 'none';
            }
        );

        Highcharts.addEvent(
            closePopupButtons[1],
            'click',
            function () {
                this.parentNode.style.display = 'none';
            }
        );

        // Add an indicator from popup
        Highcharts.addEvent(
            document.querySelectorAll('.highcharts-popup-indicators button')[0],
            'click',
            function () {
                var typeSelect = document.querySelectorAll(
                        '.highcharts-popup-indicators select'
                    )[0],
                    type = typeSelect.options[typeSelect.selectedIndex].value,
                    period = document.querySelectorAll(
                        '.highcharts-popup-indicators input'
                    )[0].value || 14;

                chart.addSeries({
                    linkedTo: 'aapl-ohlc',
                    type: type,
                    params: {
                        period: parseInt(period, 10)
                    }
                });

                chart.stockToolbar.indicatorsPopupContainer.style.display = 'none';
            }
        );

        // Update an annotaiton from popup
        Highcharts.addEvent(
            document.querySelectorAll('.highcharts-popup-annotations button')[0],
            'click',
            function () {
                var strokeWidth = parseInt(
                        document.querySelectorAll(
                            '.highcharts-popup-annotations input[name="stroke-width"]'
                        )[0].value,
                        10
                    ),
                    strokeColor = document.querySelectorAll(
                        '.highcharts-popup-annotations input[name="stroke"]'
                    )[0].value;

                // Stock/advanced annotations have common options under typeOptions
                if (chart.currentAnnotation.options.typeOptions) {
                    chart.currentAnnotation.update({
                        typeOptions: {
                            lineColor: strokeColor,
                            lineWidth: strokeWidth,
                            line: {
                                strokeWidth: strokeWidth,
                                stroke: strokeColor
                            },
                            background: {
                                strokeWidth: strokeWidth,
                                stroke: strokeColor
                            },
                            innerBackground: {
                                strokeWidth: strokeWidth,
                                stroke: strokeColor
                            },
                            outerBackground: {
                                strokeWidth: strokeWidth,
                                stroke: strokeColor
                            },
                            connector: {
                                strokeWidth: strokeWidth,
                                stroke: strokeColor
                            }
                        }
                    });
                } else {
                    // Basic annotations:
                    chart.currentAnnotation.update({
                        shapes: [{
                            'stroke-width': strokeWidth,
                            stroke: strokeColor
                        }],
                        labels: [{
                            borderWidth: strokeWidth,
                            borderColor: strokeColor
                        }]
                    });
                }
                chart.stockToolbar.annotationsPopupContainer.style.display = 'none';
            }
        );*/
    },
    show_indicators(){
      var indicatorsPopupContainer = document
          .getElementsByClassName('highcharts-popup-indicators')[0];
      indicatorsPopupContainer.style.display = 'block';
    },

    build_chart2(){
        var ohlc = []
        var volume = []
        var that=this;
        var data=this.results;
        for (var j=0;j<this.config.metrics.length;j++){
            var metric=this.config.metrics[j];
            metric.data=[];
        }
        /*var date=this.dates[this.config.date].id
        switch (date){
          case 1:
            data=this.results;
          break;
          case 2://1 wk
            data=this.filterData(this.results, 7,0,0)
          break;
          case 3://1m
            data=this.filterData(this.results, 0,1,0)
          break;
          case 4://3m
            data=this.filterData(this.results, 0,3,0)
          break;
          case 5://6m
            data=this.filterData(this.results, 0,6,0)
          break;
          case 6://9m
            data=this.filterData(this.results, 0,9,0)
          break;
          case 7://1y
              data=this.filterData(this.results, 0,0,1)
          break;
          case 8://2y
            data=this.filterData(this.results, 0,0,2)
          break;
          case 9://3y
              data=this.filterData(this.results, 0,0,3)
          break;
          case 10://5y
              data=this.filterData(this.results, 0,0,5)
          break;
          case 11://10y
            data=this.filterData(this.results, 0,0,10)
          break;
        }*/

        for (var i=0; i < data.length; i++) {
            var d=data[i];
            var dte=new Date(d["quarter_description"]).getTime()
            ohlc.push([
                dte, // the date
                d["open"], // open
                d["high"], // high
                d["low"], // low
                d["closing_price"] // close
            ]);

            volume.push([
                dte, // the date
                d["total_volume"] // the volume
            ]);
            for (var j=0;j<this.config.metrics.length;j++){
                var metric=this.config.metrics[j];
                metric.data.push([dte,d[metric.identifier]]);
            }

        }
        var s=[{
          type: this.config.chart_type,
          id: 'aapl-ohlc',
          name: window.whalewisdom.Stock.ticker+' Stock Price',
          data: ohlc,turboThreshold:0
      }]
      var addCallPutAxis=false;
      var addShortVolume=false;
      var addMvAxis=false;
      if (!this.config.compare_to_sptr){

        for (var i=0;i<this.config.metrics.length;i++){
          var metric=this.config.metrics[i];
          if (metric.visible){
            if (metric.id==8)
              addCallPutAxis=true;
            else if (metric.id==7)
              addShortVolume=true;
              else if (metric.id==15)
                addMvAxis=true;
           s.push(metric);
          }
        }
        if (!addShortVolume){
          s.push({
              type: 'column',
              id: 'aapl-volume',
              name: window.whalewisdom.Stock.ticker+' Volume',
              data: volume,
              yAxis: 1,turboThreshold:0
          })
        }

      }

      if (this.config.compare_to_sptr && this.sptr_data && this.sptr_data.length>0){
          var sptr_series_data=[];
          for (var i=0;i<this.sptr_data.length;i++){
            var d=this.sptr_data[i];
            var dte=new Date(d["quarter_description"]).getTime()
            sptr_series_data.push([
                dte, // the date
                d["open"] ? d["open"] : d["closing_price"], // open
                d["high"] ? d["high"] : d["closing_price"], // high
                d["low"] ? d["low"] : d["closing_price"], // low
                d["closing_price"] // close
            ]);
          }
        s.push({
          type: this.config.chart_type,
          id: 'sptr-ohlc',
          name: 'S&P 500 TR',
          data: sptr_series_data,turboThreshold:0
      })
      }
      var yAxis=[{
          labels: {
              align: 'left'
          },
          height: '80%',
          resize: {
              enabled: true
          },
          title:{
            text:"Price"
          }
      }, {
          labels: {
              align: 'left'
          },
          top: '80%',
          height: '20%',
          offset: 0
      },{
          labels: {
              align: 'left',
              enabled:false
          },
          height: '80%',
          offset: 0
      }]
      if (addCallPutAxis){
        yAxis.push({
            labels: {
                align: 'left',
                enabled:false
            },
            height: '80%',
            offset: 0
        })
      }
      if (addMvAxis && addCallPutAxis){
      yAxis.push({
                  labels: {
                      align: 'left',
                      enabled:false
                  },
                  height: '80%',
                  offset: 0
              })
      }
      else if (addMvAxis){
      yAxis.push({
                  labels: {
                      align: 'left',
                      enabled:false
                  },
                  height: '80%',
                  offset: 0
              })
              yAxis.push({
                          labels: {
                              align: 'left',
                              enabled:false
                          },
                          height: '80%',
                          offset: 0
                      })
      }
if (!this.config.compare_to_sptr){
         //   this.setup_theme();
        this.metrics_chart=Highcharts.stockChart('chart_container'+(this.fullscreen ? '_fullscreen' : ''), {
                title: {
                    text: window.whalewisdom.Stock.stock_name+'('+window.whalewisdom.Stock.ticker+') 13F Metrics and Pricing Data'
                },

                subtitle: {
                    text: (!whalewisdom.Utilities.isSubscriber() ? " (subscribe to see data as far back as 2001)" : "")
                },
                credits: {
                    enabled: false
                },
                chart: {
                    events: {
                        load: function () {
                            that.addPopupEvents(this);
                                var obj = document.getElementById('chart_container');
                        obj.style.removeProperty("overflow");

                        }
                    }
                },
                yAxis: yAxis,
                rangeSelector: {
                    buttons: [{
                        type: 'week',
                        count: 1,
                        text: '1w',
                    },
                      {
                        type: 'month',
                        count: 1,
                        text: '1m',
                    }, {
                        type: 'month',
                        count: 3,
                        text: '3m'
                    }, {
                        type: 'month',
                        count: 6,
                        text: '6m'
                    }, {
                        type: 'ytd',
                        text: 'YTD'
                    }, {
                        type: 'year',
                        count: 1,
                        text: '1y'
                    }, {
                        type: 'year',
                        count: 3,
                        text: '3y'
                    },{
                        type: 'year',
                        count: 5,
                        text: '5y'
                    },{
                        type: 'all',
                        text: 'All'
                    }]
                },
                navigationBindings: {
                    events: {
                        selectButton: function (event) {
                            var newClassName = event.button.className + ' highcharts-active',
                                topButton = event.button.parentNode.parentNode;

                            if (topButton.classList.contains('right')) {
                                newClassName += ' right';
                            }

                            // If this is a button with sub buttons,
                            // change main icon to the current one:
                            if (!topButton.classList.contains('highcharts-menu-wrapper')) {
                                topButton.className = newClassName;
                            }

                            // Store info about active button:
                            this.chart.activeButton = event.button;
                        },
                        deselectButton: function (event) {
                            event.button.parentNode.parentNode.classList.remove('highcharts-active');

                            // Remove info about active button:
                            this.chart.activeButton = null;
                        },
                        showPopup: function (event) {

                            if (!this.indicatorsPopupContainer) {
                                this.indicatorsPopupContainer = document
                                    .getElementsByClassName('highcharts-popup-indicators')[0];
                            }

                            if (!this.annotationsPopupContainer) {
                                this.annotationsPopupContainer = document
                                    .getElementsByClassName('highcharts-popup-annotations')[0];
                            }

                            if (event.formType === 'indicators') {
                                this.indicatorsPopupContainer.style.display = 'block';
                            } else if (event.formType === 'annotation-toolbar') {
                                // If user is still adding an annotation, don't show popup:
                                if (!this.chart.activeButton) {
                                    this.chart.currentAnnotation = event.annotation;
                                    this.annotationsPopupContainer.style.display = 'block';
                                }
                            }

                        },
                        closePopup: function () {
                            this.indicatorsPopupContainer.style.display = 'none';
                            this.annotationsPopupContainer.style.display = 'none';
                        }
                    }
                },
                stockTools: {
                    gui: {
                        enabled: false
                    }
                },
                legend: {
                        enabled: true,
                        floating: true,
                        y: -65
                    },
                    navigator: {
                            margin: 50
                        },
                series: s,
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 800
                        },
                        chartOptions: {
                            rangeSelector: {
                                inputEnabled: false
                            },
                        }
                    }]
                }
            });
          }
          else{
            Highcharts.stockChart('chart_container'+(this.fullscreen ? '_fullscreen' : ''), {
                rangeSelector: {
                  selected: 5,
                    buttons: [{
                        type: 'week',
                        count: 1,
                        text: '1w',
                    },
                      {
                        type: 'month',
                        count: 1,
                        text: '1m',
                    }, {
                        type: 'month',
                        count: 3,
                        text: '3m'
                    }, {
                        type: 'month',
                        count: 6,
                        text: '6m'
                    }, {
                        type: 'ytd',
                        text: 'YTD'
                    }, {
                        type: 'year',
                        count: 1,
                        text: '1y'
                    }, {
                        type: 'year',
                        count: 3,
                        text: '3y'
                    },{
                        type: 'year',
                        count: 5,
                        text: '5y'
                    },{
                        type: 'all',
                        text: 'All'
                    }]
                },
                yAxis: {
                    labels: {
                        formatter: function () {
                            return (this.value > 0 ? ' + ' : '') + this.value + '%';
                        }
                    },
                    plotLines: [{
                        value: 0,
                        width: 2,
                        color: 'silver'
                    }]
                },

                plotOptions: {
                    series: {
                        compare: 'percent',
                        showInNavigator: true
                    }
                },
legend: {
        enabled: true,
        floating: true,
        y: -65
    },
    navigator: {
            margin: 50
        },
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
                    valueDecimals: 2,
                    split: true
                },

                series: s
            });
          }

    }
  }
}

</script>

<style lang="scss">
@import '~@vars';
@import '~@/assets/style/main';

#nprogress .bar {
  background: $primary;
}
.v-application--wrap {min-height:inherit;}
.v-list .v-list-item--active, .v-list .v-list-item--active .v-icon {color:#66c6ba !important}

.v-window {
     overflow: visible !important;
}
.chart {
  float: left;
  /*max-height: 800px;*/
  min-height: 75vh;
  position: relative;
  width: 100%;
}
#chart_container_fullscreen{
  height:100%;
}

.highcharts-draw-mode {
  cursor: crosshair;
}

.left {
  float: left;
}

.right,
.highcharts-stocktools-toolbar li.right {
  float: right;
}

/* FULL SCREEN */
.chart:-webkit-full-screen {
  width: 100%;
  height: 100%;
}

.chart:-moz-full-screen {
  width: 100%;
  height: 100%;
}

.chart:-ms-fullscreen {
  width: 100%;
  height: 100%;
}

.chart:fullscreen {
  width: 100%;
  height: 100%;
}

/* GUI */
.highcharts-stocktools-wrapper {
  display: block;
}

.highcharts-stocktools-toolbar {
  margin: 0 0 0 10px;
  padding: 0;
  width: calc(100% - 63px);
}

.highcharts-stocktools-toolbar li {
  background-color: #f7f7f7;
  background-repeat: no-repeat;
  cursor: pointer;
  float: left;
  height: 40px;
  list-style: none;
  margin-right: 2px;
  margin-bottom: 3px;
  padding: 0;
  position: relative;
  width: auto;
}

.highcharts-stocktools-toolbar li ul {
  display: none;
  left: 0;
  padding-left: 0;
  position: absolute;
  z-index: 125;
}

.highcharts-stocktools-toolbar li ul li {
  margin-bottom: 0;
  width: 160px;
}

.highcharts-stocktools-toolbar li:hover {
  background-color: #e6ebf5;
}

.highcharts-stocktools-toolbar li:hover ul {
  display: block;
}

.highcharts-stocktools-toolbar li > span.highcharts-menu-item-btn {
  background-repeat: no-repeat;
  background-position: 50% 50%;
  display: block;
  float: left;
  height: 100%;
  width: 40px;
}

.highcharts-stocktools-toolbar li > .highcharts-menu-item-title {
  color: #666;
  line-height: 40px;
  font-size: 0.876em;
  padding: 0 10px 0 5px;
}

.highcharts-indicators > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/indicators.svg");
}

.highcharts-label-annotation > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/label.svg");
}

.highcharts-circle-annotation > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/circle.svg");
}

.highcharts-rectangle-annotation > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/rectangle.svg");
}

.highcharts-ellipse-annotation > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/ellipse.svg");
}

.highcharts-segment > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/segment.svg");
}

.highcharts-arrow-segment > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/arrow-segment.svg");
}

.highcharts-ray > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/ray.svg");
}

.highcharts-arrow-ray > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/arrow-ray.svg");
}

.highcharts-infinity-line > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/line.svg");
}

.highcharts-arrow-infinity-line > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/arrow-line.svg");
}

.highcharts-horizontal-line > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/horizontal-line.svg");
}

.highcharts-vertical-line > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/vertical-line.svg");
}

.highcharts-elliott3 > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/elliott-3.svg");
}

.highcharts-elliott5 > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/elliott-5.svg");
}

.highcharts-crooked3 > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/crooked-3.svg");
}

.highcharts-crooked5 > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/crooked-5.svg");
}

.highcharts-measure-xy > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/measure-xy.svg");
}

.highcharts-measure-x > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/measure-x.svg");
}

.highcharts-measure-y > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/measure-y.svg");
}

.highcharts-fibonacci > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/fibonacci.svg");
}

.highcharts-pitchfork > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/pitchfork.svg");
}

.highcharts-parallel-channel > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/parallel-channel.svg");
}

.highcharts-toggle-annotations > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/annotations-visible.svg");
}

.highcharts-vertical-counter > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/vertical-counter.svg");
}

.highcharts-vertical-label > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/vertical-label.svg");
}

.highcharts-vertical-arrow > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/vertical-arrow.svg");
}

.highcharts-vertical-double-arrow > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/vertical-double-arrow.svg");
}

.highcharts-flag-circlepin > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/flag-elipse.svg");
}

.highcharts-flag-diamondpin > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/flag-diamond.svg");
}

.highcharts-flag-squarepin > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/flag-trapeze.svg");
}

.highcharts-flag-simplepin > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/flag-basic.svg");
}

.highcharts-zoom-xy > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/zoom-xy.svg");
}

.highcharts-zoom-x > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/zoom-x.svg");
}

.highcharts-zoom-y > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/zoom-y.svg");
}

.highcharts-full-screen > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/fullscreen.svg");
}

.highcharts-series-type-ohlc > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/series-ohlc.svg");
}

.highcharts-series-type-line > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/series-line.svg");
}

.highcharts-series-type-candlestick > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/series-candlestick.svg");
}

.highcharts-current-price-indicator > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/current-price-show.svg");
}

.highcharts-save-chart > .highcharts-menu-item-btn {
  background-image: url("https://code.highcharts.com/gfx/stock-icons/save-chart.svg");
}

li.highcharts-active {
  background-color: #e6ebf5;
}

/* Popup */

.chart-wrapper {
  float: left;
  position: relative;
  width: 100%;
  background: white;
  padding-top: 10px;
}

/* Responsive design */

@media screen and (max-width: 1024px) {
  .highcharts-stocktools-toolbar li > .highcharts-menu-item-title {
    display: none;
  }

  .highcharts-stocktools-toolbar li ul li {
    width: auto;
  }
}
</style>
